export default "__VITE_ASSET__56cf6cc2__"